module.exports = __webpack_public_path__ + "static/img/m-footer-1.f44f625.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/m-footer-1.png
// module id = H12D
// module chunks = 21